import { render, staticRenderFns } from "./SearchExchangeCurrencyHeader.vue?vue&type=template&id=292f70a6&"
import script from "./SearchExchangeCurrencyHeader.vue?vue&type=script&lang=js&"
export * from "./SearchExchangeCurrencyHeader.vue?vue&type=script&lang=js&"
import style0 from "./SearchExchangeCurrencyHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports